<ng-template #arrowLeft>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor"
    class="size-9">
    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
  </svg>
</ng-template>
<ng-template #arrowRight>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor"
    class="size-9">
    <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
  </svg>
</ng-template>
<div class="relative overflow-hidden">
  <div class="w-full bg-black bg-opacity-30 absolute top-0 h-full"></div>
  <img src="assets/image/wundart-carousel-home.png" alt="Wundart Banner" class="w-full h-auto min-h-96 object-cover" />
  <div class="absolute inset-0 max-w-[900px] text-white flex flex-col justify-end gap-6 md:gap-10 p-6 md:p-12 pb-10 md:pb-16">
    <h1 class="text-3xl md:text-4xl lg:text-5xl font-light leading-tight max-w-[640px]" [wunEditableText]="'home.hero.title'" [fallback]="fallbacks.hero.title"></h1>
    <div class="text-base md:text-lg font-light" [wunEditableText]="'home.hero.subtitle'" [fallback]="fallbacks.hero.subtitle"></div>
  </div>
</div>

<section *transloco="let t" class="home-carousel w-full py-10 md:py-16 px-3 md:px-12">
  <div class="flex items-center justify-between gap-6 mb-8 md:mb-10">
    <h2 class="text-4xl md:text-5xl font-thin" [wunEditableText]="'home.newArtworks.title'" [fallback]="fallbacks.newArtworks.title"></h2>
    <a [routerLink]="['artworks']" wunButton primary [wunEditableText]="'home.newArtworks.discovery'" [fallback]="fallbacks.newArtworks.discovery"></a>
  </div>

  <div class="relative flex items-start gap-4">
    <button type="button" class="carousel-arrow carousel-arrow--left" aria-label="Previous"
      [class.carousel-arrow--hidden]="!showLeftArrowArtworks()" (click)="scrollLeft(artworksScroll()!)">
      <ng-container *ngTemplateOutlet="arrowLeft"></ng-container>
    </button>

    <div class="flex flex-1 min-w-0 gap-6 overflow-auto flex-nowrap hide-scrollbar scroll-smooth" #artworksScrollElement (scroll)="onScroll()">
      @for (work of artworks.value()?.data; track 'artwork_' + work.id) {
      @if (work.mainAttachment) {
      @let artist = work.artist;
      <a [routerLink]="['artworks', work.id]" class="carousel-card group">
        <div class="carousel-card__media aspect-[5/7] items-end">
          <img [src]="work.mainAttachment.url" [alt]="work.name" loading="lazy"
            class="max-w-full max-h-full object-contain object-bottom transition-opacity group-hover:opacity-90" />
        </div>
        <div class="carousel-card__info">
          <div class="font-bold line-clamp-2">{{ work.name }}</div>
          @if (artist) {
          <div>{{ work | artworkArtist }}</div>
          @if (artist.city) {
          <div>{{ artist.city }}</div>
          }
          }
          @if (work.price) {
          <div>{{ work.price | currency : 'EUR' : 'symbol' : '1.0-2' }}</div>
          }
        </div>
      </a>
      }
      }
    </div>

    <button type="button" class="carousel-arrow carousel-arrow--right" aria-label="Next"
      [class.carousel-arrow--hidden]="!showRightArrowArtworks()" (click)="scrollRight(artworksScroll()!)">
      <ng-container *ngTemplateOutlet="arrowRight"></ng-container>
    </button>
  </div>
</section>

<!-- FOR GALLERIES: text left, image right -->
<section *transloco="let t" class="home-feature grid grid-cols-1 md:grid-cols-[2fr_3fr]">
  <div class="home-feature__text order-2 md:order-1">
    <h2 class="home-feature__title" [wunEditableText]="'home.forGalleries.title'" [fallback]="fallbacks.forGalleries.title"></h2>
    <div class="flex flex-col gap-5">
      <span class="home-feature__bar"></span>
      <h3 class="home-feature__subtitle" [wunEditableText]="'home.forGalleries.subtitle'" [fallback]="fallbacks.forGalleries.subtitle"></h3>
      <p class="home-feature__description" [wunEditableText]="'home.forGalleries.description'" [fallback]="fallbacks.forGalleries.description"></p>
    </div>
    <a [routerLink]="['/join/galleries']" class="home-feature__link" [wunEditableText]="'home.forGalleries.readMore'" [fallback]="fallbacks.forGalleries.readMore"></a>
  </div>
  <div class="home-feature__media order-1 md:order-2">
    <img src="assets/image/home-for-galleries.jpg" alt="" loading="lazy" class="object-[center_70%]" />
  </div>
</section>

<section *transloco="let t" class="home-carousel w-full py-10 md:py-16 px-3 md:px-12">
  <div class="flex items-center justify-between gap-6 mb-8 md:mb-10">
    <h2 class="text-4xl md:text-5xl font-thin" [wunEditableText]="'home.newArtists.title'" [fallback]="fallbacks.newArtists.title"></h2>
    <a [routerLink]="['artists']" wunButton primary [wunEditableText]="'home.newArtists.discovery'" [fallback]="fallbacks.newArtists.discovery"></a>
  </div>

  <div class="relative flex items-start gap-4">
    <button type="button" class="carousel-arrow carousel-arrow--left" aria-label="Previous"
      [class.carousel-arrow--hidden]="!showLeftArrow()" (click)="scrollLeft(artistsScroll()!)">
      <ng-container *ngTemplateOutlet="arrowLeft"></ng-container>
    </button>

    <div class="flex flex-1 min-w-0 gap-6 overflow-auto flex-nowrap hide-scrollbar scroll-smooth" #artistsScrollElement (scroll)="onScroll()">
      @for (artist of artists.value()?.data; track 'artist_' + artist.id) {
      <a [routerLink]="['/artists', artist.id]" class="carousel-card group">
        <div class="carousel-card__media aspect-square">
          @if (artist.cover?.url) {
          <img [src]="artist.cover!.url" [alt]="artist | displayName" loading="lazy"
            class="w-full h-full object-cover transition-opacity group-hover:opacity-90" />
          } @else {
          <div class="w-full h-full bg-wundart-gray-box"></div>
          }
        </div>
        <div class="carousel-card__info">
          <div class="font-bold">{{ artist | displayName }}</div>
          @if (artist.city) {
          <div>{{ artist.city }}</div>
          }
        </div>
      </a>
      }
    </div>

    <button type="button" class="carousel-arrow carousel-arrow--right" aria-label="Next"
      [class.carousel-arrow--hidden]="!showRightArrow()" (click)="scrollRight(artistsScroll()!)">
      <ng-container *ngTemplateOutlet="arrowRight"></ng-container>
    </button>
  </div>
</section>

<!-- FOR ARTISTS: image left, text right -->
<section *transloco="let t" class="home-feature grid grid-cols-1 md:grid-cols-[3fr_2fr]">
  <div class="home-feature__media">
    <img src="assets/image/home-for-artists.jpg" alt="" loading="lazy" class="object-[center_35%]" />
  </div>
  <div class="home-feature__text">
    <h2 class="home-feature__title" [wunEditableText]="'home.forArtists.title'" [fallback]="fallbacks.forArtists.title"></h2>
    <div class="flex flex-col gap-5">
      <span class="home-feature__bar"></span>
      <h3 class="home-feature__subtitle" [wunEditableText]="'home.forArtists.subtitle'" [fallback]="fallbacks.forArtists.subtitle"></h3>
      <p class="home-feature__description" [wunEditableText]="'home.forArtists.description'" [fallback]="fallbacks.forArtists.description"></p>
    </div>
    <a [routerLink]="['/artist-experience']" class="home-feature__link" [wunEditableText]="'home.forArtists.readMore'" [fallback]="fallbacks.forArtists.readMore"></a>
  </div>
</section>

<!-- JOIN WUNDART -->
<section *transloco="let t" class="w-full py-12 md:py-20 px-3 md:px-16" id="signup">
  <h2 class="text-4xl md:text-5xl font-thin mb-8 md:mb-10" [wunEditableText]="'home.joinWundart'" [fallback]="fallbacks.joinWundart"></h2>
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
    <div class="home-join-box">
      <div class="home-join-box__title" [wunEditableText]="'home.signup.artist.title'" [fallback]="fallbacks.signup.artist.title"></div>
      <div class="flex flex-col items-center gap-3">
        <div class="home-join-box__description" [wunEditableText]="'home.signup.artist.description'" [fallback]="fallbacks.signup.artist.description"></div>
        <a [routerLink]="['/join/artists']" wunButton primary [wunEditableText]="'home.signup.artist.joinNow'" [fallback]="fallbacks.signup.artist.joinNow"></a>
      </div>
    </div>
    <div class="home-join-box">
      <div class="home-join-box__title" [wunEditableText]="'home.signup.gallery.title'" [fallback]="fallbacks.signup.gallery.title"></div>
      <div class="flex flex-col items-center gap-3">
        <div class="home-join-box__description" [wunEditableText]="'home.signup.gallery.description'" [fallback]="fallbacks.signup.gallery.description"></div>
        <a [routerLink]="['/join/galleries']" wunButton primary [wunEditableText]="'home.signup.gallery.joinNow'" [fallback]="fallbacks.signup.gallery.joinNow"></a>
      </div>
    </div>
    <div class="home-join-box">
      <div class="home-join-box__title" [wunEditableText]="'home.signup.collector.title'" [fallback]="fallbacks.signup.collector.title"></div>
      <div class="flex flex-col items-center gap-3">
        <div class="home-join-box__description" [wunEditableText]="'home.signup.collector.description'" [fallback]="fallbacks.signup.collector.description"></div>
        <a [routerLink]="['/join/collectors']" wunButton primary [wunEditableText]="'home.signup.collector.joinNow'" [fallback]="fallbacks.signup.collector.joinNow"></a>
      </div>
    </div>
  </div>
</section>

<newsletter-subscribe></newsletter-subscribe>
